module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-8-43e0746a65646745047587bb048ed2ea.jpg";